module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesUrban.b25799e.webp";